export const TRANSITION_DURATION_BASIC = 300;
